import React, { Component } from 'react';
import {Conversations} from 'api';
import {DateTime} from 'components/UI/DateTime';
import truncate from 'lodash/truncate';
import {Link, withRouter} from 'react-router-dom';
import {MessageItem, SendMessageForm} from 'components/conversations';
import {connect} from 'react-redux';
import {ShowIf} from 'components/utils';
import {toastr} from 'react-redux-toastr';

class ConversationsContainer extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      conversation: this.props.conversation,
      messages: []
    }
  }

  componentDidMount() {
    this.loadMessages();
  }

  componentWillUnmount() {
    this.props.dispatch({
      type: 'CLEAN_CONVERSATION'
    });
  }

  confirmDelete(id) {
    if (confirm("Bạn có muốn xóa tin nhắn này không?")) {
      Conversations.actions.deleteMessage.request({id}).then(response => {
        toastr.removeByType('success');
        toastr.success("", "Tin nhắn đã được xóa");

        this.loadMessages();
      });
    }
  }

  loadMessages() {
    this.props.dispatch(Conversations.actions.messages({
      id: this.state.conversation.id,
      filter: {
        include: 'user',
        limit: 50
      }
    }))
    .then(response => {
      this.props.dispatch({
        type: 'LIST_CONVERSATION_MESSAGES',
        messages: response.data
      });
    });
  }

  render() {
    return (
      <section className='need-offer-container mb35'>
        <table className="table table-striped">
          <thead>
            <tr>
              <th className='col-lg-1'></th>
              <th className='col-lg-2'>Người đăng</th>
              <th className='col-lg-5'>Nội dung</th>
              <th className='col-lg-2'>Ngày đăng</th>
              <th className='col-lg-2'>Hành động</th>
            </tr>
          </thead>

          {
            this.props.messages.map(message => {
              return (
                <MessageItem
                  message={message}
                  actionPanel={
                    <div>
                      <div className='row'>
                        <button className="btn btn-danger" type="button" onClick={this.confirmDelete.bind(this, message.id)}>Xóa</button>
                      </div>
                    </div>
                  }
                />
              )
            })
          }
        </table>

        {

        }
        <SendMessageForm
          conversation={this.props.conversation}
        />
      </section>
    );
  }

}

const mapStateToProps = (state) => {
  console.log(state.conversationMessages)
  return {
    messages: state.conversationMessages || []
  }
}

export default connect(mapStateToProps)(ConversationsContainer);



// WEBPACK FOOTER //
// ./components/conversations/Container.jsx